import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  async begin() {
    try {
      const response = await axios.get('uni/exemptions/training_systems')
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data.rs
      }
      return []
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  async getListTrainingSystemCourses(params) {
    try {
      const response = await axios.get('uni/exemptions/courses', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data.rs
      }
      return []
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  async getListCourseMajors(params) {
    try {
      const response = await axios.get('uni/reports/reportAvgStudentClass/selectCoursesMajors', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data.rs
      }
      return []
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  async getListCourseMajorClasses(params) {
    try {
      const response = await axios.get('uni/reports/reportAvgStudentClass/selectCoursesMajorsClasses', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data.rs
      }
      return []
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  async getListYearSemesters(params) {
    try {
      const response = await axios.get('uni/reports/reportAvgStudentClass/selectSemesterYears', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data.rs
      }
      return []
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  async getListSubjectsOrder(params) {
    try {
      const response = await axios.get('uni/reports/reportAvgStudentClass/selectListSubjectsOrder', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
      return null
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async getData(params) {
    try {
      const response = await axios.get('uni/reports/reportAvgStudentClass', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
      return []
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  // eslint-disable-next-line consistent-return
  async downloadExport(params) {
    try {
      const response = await axios({
        method: 'get',
        url: 'uni/reports/reportAvgStudentClassExportLAn',
        responseType: 'blob',
        params,
      })
      if (response.status.toString() === '200') {
        return response.data
      }
      return null
    } catch (e) {
      handleCatch(e)
    }
  },
}

